import { render } from "./InternalProductPriceTemplatesPage.vue?vue&type=template&id=ba843738"
import script from "./InternalProductPriceTemplatesPage.vue?vue&type=script&lang=js"
export * from "./InternalProductPriceTemplatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__